import React, { useEffect, useMemo } from 'react';
import styled from 'styled-components';
import style from './style';
import cn from 'classnames';
import VehicleList from '../../components/vehicle-list';
import { useDrop } from 'react-dnd';
import API from '../../../api';
import { useDashboardContext } from '../../context/useDashboardContext';

const ListAllVehicles = ({ className, view = {}, setTitle }) => {
  const { entityRef } = useDashboardContext();

  const vehicleCount = useMemo(() => {
    return view?.vehicles?.length || 0;
  }, [view]);

  const [collectedProps, drop] = useDrop((...args) => {
    return {
      accept: 'vehicle',
      collect: monitor => ({
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop(),
      }),
      drop: item => {
        API.statusVehicle(entityRef, item.crn, 'CREATED').then();
      },
    };
  });

  useEffect(() => {
    setTitle(`All Vehicles (${vehicleCount})`);
  }, [vehicleCount]);

  return (
    <div ref={drop} className={cn(className)}>
      <VehicleList sortByLocation showTimer={false} vehicles={view?.vehicles} />
    </div>
  );
};

export default styled(ListAllVehicles)`
  ${style}
`;
